import { ApiService } from "./ApiService"

export class WhatsappTemplateCategoryService {

    static uri = '/wa/template/category';

    static get() {
        return ApiService.get(`${this.uri}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }

    static store({ data }) {
        return ApiService.post(`${this.uri}`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }

    static update({ id, data }) {
        return ApiService.put(`${this.uri}/${id}`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }

    static destroy({ id }) {
        return ApiService.delete(`${this.uri}/${id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }
}